export default class PortfolioShareOrder {
	id: string;

	amount: number;

	amountAdjusted: number;

	executionPrice: number|null;

	executionPriceAdjusted: number|null;

	executionPriceCurrency: string|null;

	date: string|null;

	constructor(
		id: string,
		amount: number,
		amountAdjusted: number,
		executionPrice: number|null,
		executionPriceAdjusted: number|null,
		executionPriceCurrency: string | null,
		date: string,
	) {
		this.id = id
		this.amount = amount
		this.amountAdjusted = amountAdjusted
		this.executionPrice = executionPrice
		this.executionPriceAdjusted = executionPriceAdjusted
		this.executionPriceCurrency = executionPriceCurrency
		this.date = date
	}

	// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
	static deserialize(data: any): PortfolioShareOrder {
		return new this(
			data.id,
			data.amount,
			data.amount_adjusted,
			data.execution_price,
			data.execution_price_adjusted,
			data.execution_price_currency,
			data.date,
		)
	}

	serialize(): any {
		return {
			id: this.id,
			amount: this.amount,
			execution_price: this.executionPrice,
			execution_price_currency: this.executionPriceCurrency,
			date: this.date,
		}
	}
}
